import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import { graphql } from "gatsby";
import Layout from "../components/layout";
import SEO from "../components/seo";
import { Chart } from "../components/chart";
export const pageQuery = graphql`
  query {
    allCsvInfections {
      edges {
        node {
          Date
          Positive
          State
        }
      }
    }
    allCsvActions {
      edges {
        node {
          Date
          Detail
          State
        }
      }
    }
  }
`;
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  pageQuery,
  _frontmatter
};

const MDXLayout = ({
  children,
  data
}) => <Layout>
    <SEO title="Home" />
    {children}
  </Layout>;

export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1>{`Covid-19 Isolation Efficacy`}</h1>
    <p>{`The following is a report on the efficacy of isolation measures on preventing the spread of Covid-19!`}</p>
    <Chart data={props.data} mdxType="Chart" />



    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      